import api from './Api'

let cache = null

export default {
  // Catálogo de provincias de España ({ id, code, name }); se pide una sola vez
  async getAll () {
    if (!cache) {
      const response = await api().get('/provinces')
      cache = response.data.data || response.data
    }
    return cache
  }
}
